import * as z from "../../../framework";
import { ComponentOptions } from "../../../framework/components/components/component";
import { TemplateComponent } from "../../../framework/components/components/templateComponent";
import K_LoginFooter from "../templates/K_LoginFooter";

export interface LoginFooterOptions extends ComponentOptions {
    learnMoreAbout: string;
    companyURL: string;
    companyName: string;
    app?: string;
    date?: string;
}

export class LoginFooter extends TemplateComponent {

    options: LoginFooterOptions;

    constructor(options: LoginFooterOptions) {
        super(K_LoginFooter, options);
    }

    preRender() {
        const options = this.options;

        options.app = options.app || "MSI Data, LLC";
        options.date = z.util.currentYear().toString();
    }

    create() {
        $(window).bind("resize", this.resizeWindow);
        this.resizeWindow();
    }

    /*
    * ResizeWindow
    * This function will make sure everything is acceptable after a resize of the window
    *
    */
    resizeWindow() {
        // Footer positioning based on window height
        if (window.innerHeight > 662) {
            $("footer").css("position", "fixed");
        } else {
            $("footer").css("position", "absolute");
        }
    }

}
